<template>
    <div class="pc-showcase">
        <!-- Main Image -->
        <swiper :options="swiperOptionTop" ref="swiperTop">
            <swiper-slide v-for="(img, index) in pcGallery" :key="index" class="pc-showcase-selected-container">
                <img :src="img" class="pc-showcase-selected-img img-responsive">
            </swiper-slide>
        </swiper>
        <!-- Thumbnails -->
        <swiper class="pc-showcase-thumbnails" :options="swiperOptionsThumbs" ref="swiperThumbs">
            <swiper-slide v-for="(img, index) in pcGallery" :key="index">
                <div
                    class="pc-showcase-individual"
                >
                    <img :src="img" class="pc-showcase-small-images">
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "PcShowcase",
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            swiperOptionTop: {
                spaceBetween: 10,
            },
            swiperOptionsThumbs: {
                spaceBetween: 5,
                threshold: 10,
                centeredSlides: true,
                slidesPerView: 'auto',
                touchRatio: 0.2,
                slideToClickedSlide: true
            },
        }
    },
    computed: {
            ...mapState({
                cart: state => state.StarterPc.cart
            }),
            ...mapGetters({
                pcGallery: "StarterPc/pcGallery"
            })
    },
    mounted() {
        this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.swiper
            const swiperThumbs = this.$refs.swiperThumbs.swiper
            swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
        })
    }
}
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";
.pc-showcase {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .swiper-container, .swiper-wrapper, .swiper-slide {
        width: 100%;
    }
    &-selected-container {
        margin-top: 25px;
        @media (max-width: 580px) {
            height: 300px;
            width: 300px;
            margin-bottom: 80px;
        }
        @media (min-width: 580px) {
            img {
                width: 440px;
                height: 440px;
                margin: 0 auto;
            }
        }
    }
    &-thumbnails {
        display: flex;
        justify-content: center;
        margin: 20px auto 50px;
        @media (max-width: 580px) {
            margin: 5px auto 20px;
        }
        .swiper-wrapper {
            justify-content: space-around;
            transform: initial !important;
            align-items: center;
            order: 1;
            width: auto;
            .swiper-slide {
                width: auto !important;
                flex-shrink: 1;
            }
        }
    }
    &-individual {
        cursor: pointer;
        padding: 5px;
        background: rgba($grey, $alpha: 0.4);
        border: 3px solid transparent;
        width: 65px;
        height: 65px;
        padding: 4px;
        margin: 0 4px;
        border-radius: 6px;
        transition: border 0.2s;
        @media (max-width: 580px) {
            width: 40px;
            height: 40px;
            border: 2px solid transparent;
        }
        &:first-child {
            margin-left: 0;
        }
        @media (min-width: 1025px) {
            &:hover {
                border: 4px solid $orchid;
                border-radius: 8px;
                box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.21),
                    inset 0 0 12px 0 rgba(0, 0, 0, 0.18);
            }
        }
    }
    &-small-images {
        width: 100%;
        display: block;
    }
    .swiper-slide-active {
        .pc-showcase-individual {
            border: 4px solid $orchid;
            border-radius: 6px;
            width: 70px;
            height: 70px;
            @media (max-width: 580px) {
                width: 55px;
                height: 55px;
                border: 4px solid $orchid;
                border-radius: 6px;
            }
        }
    }
}
</style>

